import { useMutation } from '@tanstack/react-query';
import { queryClient } from '@/@configs/query-client';
import { eduplayClient } from '@/data/@clients';
import { clientKeys } from '@/data/@clients/client-keys';

export const useSubscribeCourse = () => {
  return useMutation({
    mutationFn: async (offerId: number) =>
      await eduplayClient.post(`/cursos/${offerId}/inscrever`),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [clientKeys.useCourseDetails],
      });
      queryClient.invalidateQueries({
        queryKey: [clientKeys.useOfferFilters],
      });
      queryClient.invalidateQueries({
        queryKey: [clientKeys.useRegistrationShow],
      });
    },
  });
};
